/**
 * Generated from ch1_p014.fla
 */
export function ch1_p014(this: Ich1_p014) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_HOLLYFPO.call(holly[0] as Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_HOLLYFPO);
		holly[0].x = 675.75;
		holly[0].y = 768;
		holly[0].width = 553.50;
		holly[0].height = 727.50;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_HOLLYFPO.call(holly[1] as Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_HOLLYFPO);
		holly[1].x = 651.75;
		holly[1].y = 768;
		holly[1].width = 663.50;
		holly[1].height = 727.50;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	if (!holly[2] && holly.elementFactory) {
		holly[2] = holly.elementFactory(2,undefined);
	}
	if (holly[2]) {
		ch1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_HOLLYFPO.call(holly[2] as Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_HOLLYFPO);
		holly[2].x = 512.75;
		holly[2].y = 768;
		holly[2].width = 359.50;
		holly[2].height = 725.50;
		holly[2].alpha = 1;
		if (holly[2].onLayout) holly[2].onLayout();
	}
	const background = this.background;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_background.call(this.background);
	background.x = 832;
	background.y = 384;
	background.width = 1664.00;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const island = this.island;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_island.call(this.island);
	island.x = 1260.25;
	island.y = 768;
	island.width = 807.50;
	island.height = 236.00;
	island.alpha = 1.00;
	if (island.onLayout) island.onLayout();
	const sigh = this.sigh;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_sigh.call(this.sigh);
	sigh.x = 719.25;
	sigh.y = 289.25;
	sigh.width = 93.50;
	sigh.height = 92.50;
	sigh.alpha = 1.00;
	if (sigh.onLayout) sigh.onLayout();
	const choresCounter = this.choresCounter;
	ch1_p014_choresCounter.call(this.choresCounter);
	choresCounter.x = 1060.25;
	choresCounter.y = 523.75;
	choresCounter.width = 178.50;
	choresCounter.height = 67.50;
	choresCounter.alpha = 1.00;
	if (choresCounter.onLayout) choresCounter.onLayout();
	const chores = this.chores;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_chores.call(this.chores);
	chores.x = 1155.25;
	chores.y = 260.5;
	chores.width = 337.50;
	chores.height = 428.00;
	chores.alpha = 1.00;
	if (chores.onLayout) chores.onLayout();
	const friends = this.friends;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_friends.call(this.friends);
	friends.x = 1051.5;
	friends.y = 250.5;
	friends.width = 551.00;
	friends.height = 479.00;
	friends.alpha = 1.00;
	if (friends.onLayout) friends.onLayout();
	const frameRight = this.frameRight;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer179.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 197.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer241copy.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 204.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const lines = this.lines;
	ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer181.call(this.lines);
	lines.x = 851.5;
	lines.y = 384;
	lines.width = 1625.00;
	lines.height = 768.00;
	lines.alpha = 1.00;
	if (lines.onLayout) lines.onLayout();
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_background(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p14_background", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_island(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_island) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p14_island", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_HOLLYFPO(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_HOLLYFPO) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p14_HOLLYFPO", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_sigh(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_sigh) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p14_sigh", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_choresCounter(this: Ich1_p014_choresCounter) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p15_chorescounter.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_HOLLYFPO(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_HOLLYFPO) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p15_HOLLYFPO.png", 0.480, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_chores(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_chores) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p15_chores.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_HOLLYFPO(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_HOLLYFPO) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p16_HOLLYFPO", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_friends(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_friends) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p16_friends", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer179(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer179) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer179", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer241copy(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer241copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer241copy", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer181(this: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer181) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer181", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich1_p014Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p014Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p014Sprite extends Ich1_p014Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p014Text extends Ich1_p014Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p014Polygon extends Array<number> {
}
interface Ich1_p014 {
	readonly holly: Ich1_p014Array<Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_HOLLYFPO|Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_HOLLYFPO|Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_HOLLYFPO>;
	readonly background: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_background;
	readonly island: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_island;
	readonly sigh: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_sigh;
	readonly choresCounter: Ich1_p014_choresCounter;
	readonly chores: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_chores;
	readonly friends: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_friends;
	readonly frameRight: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer179;
	readonly frameLeft: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer241copy;
	readonly lines: Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer181;
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_background extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_island extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_HOLLYFPO extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP14ch1_p14_sigh extends Ich1_p014Sprite {
}
interface Ich1_p014_choresCounter extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_HOLLYFPO extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP15ch1_p15_chores extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_HOLLYFPO extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetP16ch1_p16_friends extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer179 extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer241copy extends Ich1_p014Sprite {
}
interface Ich1_p014_hh_ch1_72dpi_p014015016psdAssetch1_p14_wcframeLayer181 extends Ich1_p014Sprite {
}
